import { appstr } from "@coreapp/utils/appstr";
import { Button, ButtonProps } from "@theorgchartdev/storybook";
import { useToolbarButtonTooltip } from "./useToolbarButtonTooltip";
import { useTableInstanceContext } from "@/providers/PlanningTabularProvider";

interface UnassignEmployeeProps extends ButtonProps {}

export const UnassignEmployee = (props: UnassignEmployeeProps) => {
  const { selectedPositionsCount, isClosedOrUnassignedPositionsSelected } =
    useTableInstanceContext();

  const noPositionSelected = selectedPositionsCount === 0;
  const closedOrUnassignedPositionsSelected = isClosedOrUnassignedPositionsSelected();
  const isDisabled = noPositionSelected || closedOrUnassignedPositionsSelected;

  const tooltipProps = useToolbarButtonTooltip("unassign");

  return (
    <Button
      {...props}
      disabled={isDisabled}
      iconProps={{
        name: "user-minus",
        title: "user-minus"
      }}
      modifier="secondary"
      tooltipProps={tooltipProps}
    >
      {appstr("Unassign")}
    </Button>
  );
};
